import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class EnumDeclarationCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.EnumDeclaration;
    }
    visitNode(sb, decl, _options) {
        sb.context.reportUnsupported(decl);
    }
}

//# sourceMappingURL=EnumDeclarationCompiler.js.map
